<template>
  <div class="mb-4">
    <v-row class="px-2" no-gutters>
      <v-col
        align-self="center"
        cols="auto"
        @click="$router.push(`/garden/${tip.userId}`)"
      >
        <v-img
          class="shrink rounded-circle ma-3"
          :src="tip.userProfilePictureUrl"
          transition="fade-transition"
          height="40"
          width="40"
        >
          <template v-slot:placeholder>
            <v-row class="fill-height ma-0" align="center" justify="center">
              <v-icon size="24" color="primary">mdi-account-outline</v-icon>
            </v-row>
          </template>
        </v-img></v-col
      >
      <v-col
        align-self="center"
        cols="auto"
        @click="$router.push(`/garden/${tip.userId}`)"
      >
        <v-row
          no-gutters
          class="font-weight-bold text-subtitle-2 secondary--text"
          >{{ tip.userNickname
          }}<span class="mx-1 font-weight-regular tertiary--text">
            shares a tip</span
          >
        </v-row>
        <v-row no-gutters class="text-caption grey--text">{{
          handleISOToRelativeTime(tip.createdAt.toDate())
        }}</v-row>
      </v-col>
      <v-col></v-col>
      <v-col cols="auto" align-self="center">
        <div
          v-if="tip.loversId"
          class="mr-4"
          @click="
            $emit(
              'toggleLove',
              {
                itemId: tip.id,
                parentId: tip.userId,
                target: 'tips',
                self,
                deep: true,
              },
              tip
            )
          "
        >
          <div class="secondary--text text-h6 mr-1 mt-3 d-inline-block">
            {{ tip.loversId.length }}
          </div>
          <v-icon
            :size="28"
            class="mb-2"
            :color="tip.loversId.includes(self.id) ? 'warning' : 'secondary'"
            >{{
              tip.loversId.includes(self.id)
                ? "mdi-lightbulb-on"
                : "mdi-lightbulb-on-outline"
            }}</v-icon
          >
        </div>
      </v-col>
      <!-- <v-col cols="auto">
        <v-row no-gutters
          ><v-btn
            v-if="tip.loversId"
            icon
            class="ma-3"
            @click="
              toggleLove(
                {
                  itemId: tip.id,
                  parentId: tip.userId,
                  target: 'tips',
                  self,
                  deep: true,
                },
                tip
              )
            "
          >
            <v-icon
              :size="28"
              :color="tip.loversId.includes(self.id) ? 'warning' : 'secondary'"
              >{{
                tip.loversId.includes(self.id)
                  ? "mdi-lightbulb-on"
                  : "mdi-lightbulb-on-outline"
              }}</v-icon
            ></v-btn
          ></v-row
        >
      </v-col> -->
    </v-row>

    <v-row
      no-gutters
      class="px-3"
      v-for="(content, index) in tip.content"
      :key="index"
    >
      <div v-if="content.text" class="px-2 mb-2">{{ content.text }}</div>
      <v-img
        v-if="content.pictureUrl"
        @click="$store.commit('fullScreenPicture/setUrl', content.pictureUrl)"
        class="shrink rounded-xl mb-2"
        :src="content.pictureUrl"
        transition="fade-transition"
        width="100%"
        height="200"
        ><template v-slot:placeholder>
          <v-row class="fill-height ma-0" align="center" justify="center">
            <v-progress-circular
              indeterminate
              color="primary"
            ></v-progress-circular>
          </v-row>
        </template>
      </v-img>
    </v-row>
  </div>
</template>

<script>
import { ISOToRelativeTime } from "@/utils/dates.js";

export default {
  name: "Tip",
  props: ["tip", "self"],
  methods: {
    handleISOToRelativeTime(date) {
      return ISOToRelativeTime(date);
    },
    // goToPlant() {
    //   this.$router.push(`/garden/${this.plant.userId}/plant/${this.plant.id}`);
    // },
  },
};
</script>